import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_MATERIAL, GET_MATERIAL_MSB } from '@/graphql/Mystage/material';
import { SALES_TRIAL_MATERIALS } from '@/graphql/salesTrial';
import { bizmatesApi } from '@/utils/bizmatesApi';
import { mystageServiceIdHeaderName } from '@/utils/constants';
import store from '@/store';
import logger from '@/modules/Logger';

export const GetMaterialService = {
  // Method to fetch Material from new GraphQL endpoint
  msb: async (booking_id, test, isTrial, callback, jwtKeyValue, preload = 0) => {
    if (isTrial) {
      logger.debug('[Materials] Fetching trial materials from MSB endpoint', {
        operation: 'materials:get_trial_materials'
      });

      if (!jwtKeyValue?.k || !jwtKeyValue?.v) {
        logger.error('[Materials] Missing k/v for trial materials', {
          operation: 'materials:get_trial_materials'
        });
        return;
      }

      const serviceId = store.state.triallesson.serviceId;

      try {
        const client = myStageApolloProvider.defaultClient;
        const { data } = await client.query({
          query: SALES_TRIAL_MATERIALS,
          fetchPolicy: 'no-cache',
          variables: { k: jwtKeyValue.k, v: jwtKeyValue.v },
          context: {
            authRequired: false,
            headers: {
              [mystageServiceIdHeaderName]: serviceId
            }
          }
        });

        if (data?.salesTrialMaterials) {
          callback(data.salesTrialMaterials);
        } else {
          logger.warn('[Materials] Empty result from trial materials query', {
            operation: 'materials:get_trial_materials'
          });
        }
      } catch (error) {
        logger.error('[Materials] Failed to fetch trial materials', {
          operation: 'materials:get_trial_materials',
          error
        });
      }

      return;
    }

    logger.debug(`[Materials] Fetching Materials from MSB endpoint`, {
      operation: 'materials:get_materials'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_MATERIAL_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        b: parseInt(booking_id),
        test: parseInt(test),
        preload: preload,
      }
    });

    if (data?.getMaterials) {
      callback(data.getMaterials);
    } else {
      logger.error(
        '[Materials] Empty result from MSB materials api',
        { operation: 'materials:get_materials' }
      );
    }
  },

  // Method to fetch Material from new GraphQL endpoint
  mbti: async (booking_id, test, isTrial, callback, jwtKeyValue, preload = 0) => {
      logger.debug(`[Materials] Fetching Materials from MBTI GraphQL endpoint`, {
        operation: 'materials:get_materials'
      });

      const client = apolloProvider.defaultClient;
      const { data } = await client.query({
        query: GET_MATERIAL,
        fetchPolicy: 'no-cache',
        variables: {
          b: parseInt(booking_id),
          test: parseInt(test),
          preload: preload,
        }
      });
      
      if (data?.mystage_get_materials) {
        callback(data.mystage_get_materials);
      } else {
        logger.error(
            '[Materials] Empty result from MBTI materials api',
            { operation: 'materials:get_materials' }
          );
      }
  },

  // Method to fetch Material from legacy REST API endpoint
  legacy: async (booking_id, test, isTrial, callback, jwtKeyValue, preload = 0) => {
    logger.debug(`[Materials] Fetching Materials from legacy endpoint`, {
      operation: 'materials:get_materials'
    });

    let path,
        params = {};
    if (isTrial) {
      path = 'sales/materials';
      params = {
        params: {...jwtKeyValue}
      };
    } else {
      path = `materials/materials.json?b=${booking_id}&test=${test}&preload=${preload}`;
    }

    await bizmatesApi.get(path, params, response => {
      if (response.data && response.data.length) {
        callback(response.data);
      } else {
        logger.error(
          `[Materials] Empty result from legacy materials api`,
          { operation: 'materials:get', event_type: 4 }
        );
      }
    });
  }
};